module.exports = __webpack_public_path__ + "static/media/yoda.210d1142.png";